import React from 'react';
import styled from 'styled-components';
import useWindowWidth from '../../hooks/useWindowSize';
import { Button } from '../styles/Hero.styles';

const Card = styled.div`
  padding: 32px;
  border: 1px solid #bddbff;
  border-radius: 16px;
  text-align: left;
  box-shadow: 6px 6px 40px 0 #e7e7e7;

  h3 {
    font-weight: 600;
    margin-top: 24px;
    font-family: Poppins, sans-serif;
  }
  p {
    margin-top: 16px;
  }

  &:hover {
    background-color: #e5f2f6;

    h3 {
      color: #253ec6;
    }

    svg {
      /* path[opacity='0.4'] {
        fill: #253ec6;
        opacity: 1;
      }
      .hover-white {
        fill: #fff !important;
      } */
    }
  }

  @media (max-width: 600px) {
    padding: 16px;
    width: 100%;

    svg {
      width: 40px;
      height: 40px;
    }
    p {
      margin-top: 8px;
    }
    h3 {
      margin-top: 12px;
    }

    :not(:first-of-type) {
      margin-top: 16px;
    }
  }
`;

function Easy123(props) {
  const { width } = useWindowWidth();
  return (
    <section className="how_it_works container">
      <h2 className="headline-2 center w-100">It's as easy as 1-2-3</h2>
      <p>
        We've taken great measures to build the easiest way to book a cleaning.
        Try it!
      </p>
      <div
        className="row"
        style={{ margin: '10vh auto', gap: width < 768 ? 16 : 'auto' }}
      >
        <div className="col-sm-12 col-md-4">
          <Card>
            <BookOnlineIcon />
            <h3>Book online</h3>
            <p>
              Tell us about your home and your needs, and we'll give you a price
              so you can schedule your first visit.
            </p>
          </Card>
        </div>
        <div className="col-sm-12 col-md-4">
          <Card>
            <GetConfirmationIcon />
            <h3>Get confirmation</h3>
            <p>
              We'll confirm your appointment and send you automated reminders
              via email and SMS.
            </p>
          </Card>
        </div>
        <div className="col-sm-12 col-md-4">
          <Card>
            <SitBackAndRelaxIcon />
            <h3>Sit back and relax</h3>
            <p>
              Our dedicated customer care team is always there to help and will
              make sure that your are 100% happy.
            </p>
          </Card>
        </div>
      </div>
      <div className="w-100 center">
        <Button
          onClick={() => {
            window.location.href =
              'https://booking.heyhomero.com?utm_source=website&utm_medium=button&utm_campaign=new_york_page';
          }}
          style={{ background: '#253ec6' }}
        >
          Get started
        </Button>
      </div>
    </section>
  );
}

function BookOnlineIcon() {
  return (
    <svg
      width="79"
      height="69"
      viewBox="0 0 79 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.4215 33.0879C49.4215 26.1962 55.0567 20.5609 61.9484 20.5609H77.1712C77.8051 20.5609 78.321 20.0439 78.2818 19.4112C77.6132 8.59843 68.6068 0 57.6459 0H26.6903C15.2675 0 5.97705 9.29049 5.97705 20.7132V46.3763C5.97705 46.9494 5.99662 47.522 6.0497 48.0951C6.08861 48.5147 6.37917 48.86 6.76408 49.0317C7.78333 49.4871 8.74124 50.1306 9.59425 50.9835L10.4985 51.8878C10.9452 52.3344 11.6695 52.3337 12.1154 51.8863L21.9689 41.9976C25.7003 38.2662 31.7163 38.2662 35.4477 41.9976C39.1791 45.691 39.1791 51.7069 35.4477 55.4384L25.6592 65.2597C24.9908 65.9302 25.3846 67.0656 26.3312 67.0858C26.4503 67.0884 26.57 67.0896 26.6903 67.0896H57.6459C69.1429 67.0896 77.7354 57.7659 78.2925 46.719C78.3241 46.0889 77.8097 45.5767 77.1788 45.5767H61.9484C55.0567 45.5767 49.4215 39.9796 49.4215 33.0879Z"
        fill="#253EC6"
        className="evenodd"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M65.1477 32.8536C65.1477 34.4527 63.8532 35.7092 62.292 35.7092C60.6929 35.7092 59.4364 34.4527 59.4364 32.8536C59.4364 31.2925 60.6929 29.9979 62.292 29.9979C63.8532 29.9979 65.1477 31.2925 65.1477 32.8536ZM55.1338 33.082C55.1338 36.8134 58.1799 39.8595 61.9494 39.8595H77.1797C77.8106 39.8595 78.322 39.3482 78.322 38.7172V27.4087C78.322 26.778 77.8106 26.2666 77.1797 26.2666H61.9494C58.1799 26.2666 55.1338 29.3125 55.1338 33.082Z"
        fill="#253EC6"
        className="evenodd"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.7377 46.6873C29.622 45.5717 27.8134 45.5717 26.6978 46.6873L11.3038 62.1042L4.87656 55.6732C3.76094 54.5576 1.95234 54.5576 0.836716 55.6732C-0.278905 56.7888 -0.278905 58.5974 0.836716 59.713L9.28574 68.1659C9.82261 68.6989 10.5499 68.9997 11.3038 68.9997C12.0653 68.9997 12.7925 68.6989 13.3256 68.1659L30.7415 50.7271C31.8533 49.6115 31.8533 47.7991 30.7377 46.6873Z"
        fill="#253EC6"
        className="evenodd"
      />
    </svg>
  );
}

export function GetConfirmationIcon() {
  return (
    <svg
      width="83"
      height="69"
      viewBox="0 0 83 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.7232 21.7738L48.2497 37.7729C47.155 41.6464 42.9868 44.5937 38.8607 44.5937C38.4397 44.5937 38.0607 44.5937 37.6397 44.5095L20.8827 42.4043C19.1565 42.1938 17.8934 40.636 18.146 38.9097C18.3565 37.1414 19.9564 35.9204 21.6406 36.173L38.4818 38.2782C39.9554 38.4887 41.8079 37.2677 42.229 35.9204L47.7445 19.7529C48.3339 18.1108 50.1023 17.1846 51.7443 17.774C53.4284 18.3635 54.2705 20.1318 53.7232 21.7738Z"
        fill="#253EC6"
        className="hover-white"
      />
      <path
        opacity="0.4"
        d="M62.439 62.6544C62.439 62.6544 -26.2544 62.6544 13.3468 62.6544L4.75764 49.2656C1.76831 44.4237 0.589506 38.9924 1.38947 33.8979C2.27364 28.5508 5.34713 24.0038 10.0627 21.0987L38.2297 2.99427C42.9873 0.047046 48.4186 -0.752916 53.6394 0.720698C58.6497 2.15221 63.0285 5.60468 65.9757 10.4044L77.3436 28.4666C83.7012 38.7398 81.4276 50.8655 72.0386 56.6337L62.439 62.6544Z"
        fill="#253EC6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 65.8423C0 64.0984 1.41379 62.6846 3.15774 62.6846H78.9436C80.6875 62.6846 82.1014 64.0984 82.1014 65.8423C82.1014 67.5867 80.6875 69.0001 78.9436 69.0001H3.15774C1.41379 69.0001 0 67.5867 0 65.8423Z"
        fill="#253EC6"
      />
    </svg>
  );
}

export function SitBackAndRelaxIcon() {
  return (
    <svg
      width="71"
      height="69"
      viewBox="0 0 71 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.9578 57.8493C42.9578 55.2737 44.2902 52.8843 46.475 51.5258L50.5154 49.0135C50.6609 48.9227 50.7838 48.7999 50.8742 48.6544L53.3828 44.6143C54.7412 42.4295 57.1344 41.1008 59.7062 41.1008C61.2326 41.1008 62.6741 41.5869 63.8818 42.4351C64.5994 42.9387 65.7033 42.709 65.9236 41.8608C66.6185 39.1867 66.9937 36.3852 66.9937 33.497C66.9937 15.0289 51.9684 0 33.4968 0C15.0289 0 0 15.0289 0 33.497C0 51.9687 15.0289 66.9939 33.4968 66.9939C37.4319 66.9939 41.2085 66.3084 44.716 65.0567C45.5571 64.7567 45.6688 63.6096 45.0521 62.9631C43.7502 61.5979 42.9578 59.8405 42.9578 57.8493Z"
        fill="#253EC6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4556 39.4107C20.4556 38.3686 21.3116 37.5498 22.3165 37.5498H45.0572C46.0621 37.5498 46.9182 38.3686 46.9182 39.4107C46.9182 45.7752 40.9632 50.9486 33.7055 50.9486C26.4106 50.9486 20.4556 45.7752 20.4556 39.4107Z"
        fill="#253EC6"
        className="hover-white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.795 24.6083C18.7876 23.663 19.1635 22.7437 19.8446 22.0551C20.5331 21.3628 21.4487 20.9795 22.4239 20.9795C24.4262 20.9795 26.0527 22.6097 26.0527 24.6083C26.0527 26.6107 24.4262 28.2409 22.4276 28.2409C20.4252 28.2409 18.795 26.6107 18.795 24.6083Z"
        fill="#253EC6"
        className="hover-white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.0365 22.0551C44.725 21.3628 45.6406 20.9795 46.6158 20.9795C48.6181 20.9795 50.2446 22.6097 50.2446 24.6083C50.2446 26.6107 48.6181 28.2409 46.6195 28.2409C44.6171 28.2409 42.9869 26.6107 42.9869 24.6083C42.9795 23.663 43.3554 22.7437 44.0365 22.0551Z"
        fill="#253EC6"
        className="hover-white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69.9932 56.2716L64.6337 52.9219L62.6983 49.8328L61.284 47.5624C60.6141 46.4831 58.8276 46.4831 58.1204 47.5624L54.8079 52.9219L49.4112 56.2716C48.8902 56.6066 48.5552 57.2021 48.5552 57.8348C48.5552 58.5048 48.8902 59.1003 49.4112 59.4352L52.2771 61.2217L54.8079 62.7849L58.1204 68.1444C58.4554 68.7027 59.0509 69.0005 59.7208 69.0005C60.3535 69.0005 60.949 68.7027 61.284 68.1444L64.6337 62.7849L69.9932 59.4352C70.5515 59.1003 70.8864 58.5048 70.8864 57.8348C70.8864 57.2021 70.5515 56.6066 69.9932 56.2716Z"
        fill="#253EC6"
      />
    </svg>
  );
}

export default Easy123;